import { type TAudioSuggestions } from '@core/models'
import { convertAudioSuggestions } from '@core/converters'

import { useAudioScreenLoaderData } from './useAudioScreenLoaderData'

/**
 * No fallback on purpose: `AudioPageDto::$suggestions` defaults to empty lists and the claim gateway
 * sends the same shape, so the payload always carries the envelope.
 */
export const useAudioScreenSuggestions = (): TAudioSuggestions | undefined => {
    const { suggestions } = useAudioScreenLoaderData()

    return suggestions ? convertAudioSuggestions(suggestions) : undefined
}
